import React from 'react';

import { twMerge } from 'tailwind-merge';

interface Props {
  id?: string;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
  variant?: 'primary' | 'secondary' | 'danger';
  btn_size?: 'small' | 'big';
  icon_position?: 'hor' | 'ver';
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit';
}

export default function Button({
  id,
  children,
  onClick,
  variant = 'primary',
  btn_size = 'small',
  icon_position = 'hor',
  className,
  disabled = false,
  type,
}: Props) {
  const variantToClass = {
    primary: ' bg-blue-500 text-white',
    danger: ' bg-red-450 text-white ',
    secondary: ' border border-gray-300 bg-white text-gray-700 box-shadow-100',
  };
  const variantToSize = {
    small: 'text-sm font-semibold',
    big: 'text-base font-semibold',
  };
  const commonStyle =
    'flex items-center justify-center rounded-md px-4 py-2  ' +
    (icon_position == 'hor' ? ' gap-x-2.5 flex-row ' : ' gap-0.5 flex-col ');

  const variantToStyle = {
    primary: {},
    danger: {},
    secondary: {},
  };
  function handleClick(event) {
    if (onClick) {
      event?.preventDefault();
      onClick(event);
    }
  }

  return (
    <button
      id={id ?? 'button_id'}
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={twMerge(commonStyle, variantToClass[variant], variantToSize[btn_size], className)}
      style={variantToStyle[variant]}
    >
      {children}
    </button>
  );
}
